import { applySnapshot, flow, Instance, types } from 'mobx-state-tree';
import { FFmpeg } from '../../http-requests';
import { RequestStateModel } from './general-models';

export interface IPreviewerStore extends Instance<typeof PreviewerStore> {}

const FileObjModel = types.model({
  file: types.custom<File, File>({
    name: 'File',
    fromSnapshot(value: File) {
      return value;
    },
    toSnapshot(value: File) {
      return value;
    },
    isTargetType(value: File): boolean {
      return value instanceof File;
    },
    getValidationMessage(value: File): string {
      return '';
    },
  }),
  otherInformation: types.optional(types.frozen<{ [key: string]: any }>(), {}),
});

const DataModel = types.model({
  files: types.optional(types.array(FileObjModel), []),
});

const StatusesModel = types.model({
  getFiles: types.optional(RequestStateModel, {}),
  getCompressedVideo: types.optional(RequestStateModel, {}),
});

export const PreviewerStore = types
  .model({
    showPreviewerWindow: types.optional(types.boolean, false),
    activeSlideIndex: types.optional(types.number, 0),
    data: types.optional(DataModel, {}),
    statuses: types.optional(StatusesModel, {}),
  })
  .views((self) => ({
    // Views
  }))
  .actions((self) => ({
    setShowPreviewerWindow: (payload: boolean) => {
      self.showPreviewerWindow = payload;
    },

    setActiveSlideIndex: (payload: number) => {
      self.activeSlideIndex = payload;
    },

    clearFiles: () => {
      applySnapshot(self.data, {});
      self.showPreviewerWindow = false;
    },

    updateLocalFiles: (
      // arrayBuffers: any,
      files: any
    ) => {
      self.data = {
        ...self.data,
        // arrayBuffers,
        files,
      };
    },

    replaceLocalFile: (index: number, FileObj: any) => {
      self.data.files.splice(index, 1, FileObj);
    },

    updateFileOtherInformationByIndex: (
      currentPreviewSlideIndex: number,
      entries: {
        field?: string;
        fileId?: string;
        index?: number;
      }
    ) => {
      const oldFileObj = self.data.files[currentPreviewSlideIndex];
      const updatedFileObj = {
        file: oldFileObj.file,
        otherInformation: {
          ...oldFileObj.otherInformation,
          ...entries,
        },
      };

      self.data.files.splice(currentPreviewSlideIndex, 1, updatedFileObj);
    },

    getFiles: flow(function* (
      links: any,
      toDownloadAndTransform: {
        url: string;
        otherInformation: { [propName: string]: any };
      }[],
      files: any
    ) {
      try {
        const response = yield Promise.all(
          toDownloadAndTransform.map((link) =>
            fetch(link.url).then(async (response) => {
              const blob = await response.blob();
              // Есть проблемы с кириллицей при получении названия файла из response.headers
              // const fileNameFromResponseHeaders = response.headers.get(
              //   'content-disposition'
              // );

              const fileFromBlob = new File(
                [blob],
                // fileNameFromResponseHeaders
                //   ? fileNameFromResponseHeaders
                //     .split('filename=')[1]
                //     .split(';')[0]
                //   : '',
                link.otherInformation.fileName,
                {
                  type: response.headers.get('content-type') || '',
                }
              );

              return {
                file: fileFromBlob,
                otherInformation: link.otherInformation,
              };
            })
          )
        );

        self.data = {
          files: [...response, ...files] as any,
        };

        self.statuses.getFiles.successStates();
      } catch (error) {
        console.error(error);
        self.statuses.getFiles.error = true;

        throw error;
      } finally {
        self.statuses.getFiles.pending = false;
      }
    }),

    getCompressedVideo: flow(function* (file: File) {
      self.statuses.getCompressedVideo.fulfilled = false;
      self.statuses.getCompressedVideo.error = false;
      self.statuses.getCompressedVideo.pending = true;

      try {
        const data = new FormData();
        data.append('data', file as File);
        const response = yield FFmpeg.CompressRequestVideo(data);
        self.statuses.getCompressedVideo.fulfilled = true;

        return response;
      } catch (e) {
        console.error(e);
        self.statuses.getCompressedVideo.error = true;
      } finally {
        self.statuses.getCompressedVideo.pending = false;
      }
    }),

    // getFiles: flow(function* (
    //   links: any,
    //   toDownloadAndTransform: {
    //     url: string;
    //     otherInformation: { [propName: string]: any };
    //   }[],
    //   files: any
    // ) {
    //   try {
    //     self.statuses.getFiles.loadingStates();
    //
    //     const filesWithSharedId: {
    //       id: string;
    //       otherInformation: { [propName: string]: any };
    //     }[] = yield Promise.all(
    //       toDownloadAndTransform.map(async (file) => {
    //         const sharedId = await Requests.GetRequestFileSharedId({
    //           file_id: file.otherInformation.fileId,
    //           filename: file.otherInformation.fileName,
    //         });
    //
    //         return {
    //           id: sharedId.shared_id,
    //           otherInformation: file.otherInformation,
    //         };
    //       })
    //     );
    //
    //     const response = yield Promise.all(
    //       filesWithSharedId.map(async (file) => {
    //         const blob = await Files.GetFileFromFilesMS(file.id);
    //
    //         // Есть проблемы с кириллицей при получении названия файла из response.headers
    //         // const fileNameFromResponseHeaders = response.headers.get(
    //         //   'content-disposition'
    //         // );
    //
    //         const fileFromBlob = new File(
    //           [blob],
    //           // fileNameFromResponseHeaders
    //           //   ? fileNameFromResponseHeaders
    //           //     .split('filename=')[1]
    //           //     .split(';')[0]
    //           //   : '',
    //           file.otherInformation.fileName,
    //           {
    //             type: blob.headers.get('content-type') || '',
    //           }
    //         );
    //
    //         return {
    //           file: fileFromBlob,
    //           otherInformation: file.otherInformation,
    //         };
    //       })
    //     );
    //
    //     self.data = {
    //       files: [...response, ...files] as any,
    //     };
    //
    //     self.statuses.getFiles.successStates();
    //   } catch (error) {
    //     console.log('PreviewerStore: getFiles promise down');
    //     self.statuses.getFiles.errorStates();
    //
    //     return Promise.reject(error);
    //   } finally {
    //     self.statuses.getFiles.finallyStates();
    //   }
    // }),
  }));
